.handles {
  user-select: none;
  touch-action: pan-y;
}

.band {
  fill: transparent;
  cursor: grab;
}

.handles[data-dragging='band'] .band {
  cursor: grabbing;
}

.handle {
  cursor: ew-resize;
  outline: none;
}

.grab {
  fill: transparent;
}

.line {
  stroke: var(--text-primary);
  stroke-width: 1;
}

.grip {
  fill: var(--white);
  stroke: var(--text-primary);
  stroke-width: 1;
}

.handle:hover .line,
.handle[data-active] .line {
  stroke-width: 2;
}

.handle:hover .grip,
.handle[data-active] .grip {
  stroke-width: 2;
}

.handle:focus-visible .grip {
  stroke: var(--light-blue);
  stroke-width: 2;
}
